import { CircularProgress, IconButton, styled } from "@mui/material";
import { Draggable } from "react-beautiful-dnd";
import DeleteIcon from "components/icons/Components/DeleteIcon";
import colors from "theme/themeConstants";
import { ReactComponent as ArrowIcon } from "components/icons/left_arrow.svg";

interface IProps {
  dataUrl: string;
  fileName: string;
  index: number;
  removeFileFromArray: (index: number) => void;
  progressPercent: number;
  id: string;
}

const UploadMultipleItem = (props: IProps) => {
  const { dataUrl, fileName, removeFileFromArray, index, progressPercent, id } = props;

  return (
    <Draggable draggableId={id} index={index}>
      {(provided, snapshot) => (
        <Container
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={snapshot.isDragging ? "dragging" : ""}
        >
          <FlexContainer>
            <DragIcon>
              <ArrowIcon />
              <ArrowIcon />
            </DragIcon>
            <ImgContainer>
              <ImgPreview src={dataUrl} alt="preview"/>
              <CircularProgress
                sx={{ position: "absolute", color: colors.purple, zIndex: 1 }}
                variant="determinate"
                value={progressPercent}
              />
            </ImgContainer>
            <p>{fileName}</p>
          </FlexContainer>
          <IconButton onClick={() => removeFileFromArray(index)}>
            <DeleteIcon/>
          </IconButton>
        </Container>
      )}
    </Draggable>
  );
};

export default UploadMultipleItem;

const Container = styled("div")({
  width: "100%",
  background: colors.cardBackgroundDarkBlue,
  padding: "8px",
  borderRadius: "12px",
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "& button": {
    color: "white",
    border: `1.5px solid ${colors.purple}`
  },
  "& svg path": {
    opacity: 1
  },
  "@media screen and (max-width: 767px)": {
    width: "100%"
  }
});

const FlexContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "1rem",
  overflow: "hidden",
  "& p": {
    fontSize: "14px",
    fontWeight: 500,
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textAlign: "left"
  }
});

const ImgPreview = styled("img")({
  width: "44px",
  height: "44px",
  objectFit: "cover",
  borderRadius: "6px"
});

const ImgContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyItems: "center",
  position: "relative"
});

const DragIcon = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  "svg": {
    height: 25,
    width: "auto",
    position: "relative",
    transform: "rotate(-90deg)",
    top: -5,
    "&:first-of-type": {
      top: 5,
      transform: "rotate(90deg)"
    }
  },

  "path": {
    stroke: "#D8DFEC",
    opacity: "0.4!important"
  }
});
